import { render, staticRenderFns } from "./HeaderImg.vue?vue&type=template&id=42d9cc2a&"
import script from "./HeaderImg.vue?vue&type=script&lang=js&"
export * from "./HeaderImg.vue?vue&type=script&lang=js&"
import style0 from "./HeaderImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports